module.exports = __webpack_public_path__ + "static/img/pCT4.8beee8c3.png";